import CensusManagementRouteProvider from 'enrollment-platform/pages/CensusManagement/components/CensusManagementRouteProvider'
import React from 'react'

export const withCensusManagementV2RouteProvider = <P extends object>(
  Component: React.ComponentType<P>
) => {
  return (props: P) => (
    <CensusManagementRouteProvider version="v2">
      <Component {...props} />
    </CensusManagementRouteProvider>
  )
}

export const withCensusManagementV1RouteProvider = <P extends object>(
  Component: React.ComponentType<P>
) => {
  return (props: P) => (
    <CensusManagementRouteProvider version="v1">
      <Component {...props} />
    </CensusManagementRouteProvider>
  )
}
